import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Select, Spin } from "antd";
import PurchaseOrderServices from "../../services/purchaseOrder.service";
import "../../assets/css/po2-design.css";

// Epic 1857 UI-redesign Phase 9: a direct nav entry for the organizer's "Order Log"
// (prototype's oOrders()), instead of that capability only being reachable via a
// dashboard drill-through click. The screen itself is F7's OrderReport.js, reused as-is
// (F8's ResolveOrganizerViewAsync already switches its backend scoping to "this show's
// orders" whenever the caller is a confirmed organizer and a showId filter is present -
// no new endpoint needed) - this component's only job is picking which show, then
// handing off via the same router-state drill-through OrganizerDashboard.js already uses.
// Same "exactly one show -> auto-select, otherwise a dropdown" pattern as F6's show
// auto-detection on the vendor order builder.
const OrderLog = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";
  const navigate = useNavigate();
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    PurchaseOrderServices.GetMyShows()
      .then((res) => {
        setLoading(false);
        const list = res?.data?.status ? res.data.responseData || [] : [];
        setShows(list);
        if (list.length === 1) {
          navigate("/orderReport", { state: { showId: list[0].showId }, replace: true });
        }
      })
      .catch(() => setLoading(false));
  }, [navigate]);

  if (loading || shows.length === 1) {
    return (
      <div className="po2-scope" dir={isRtl ? "rtl" : "ltr"}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className="po2-scope" dir={isRtl ? "rtl" : "ltr"}>
      <div className="po2-phead">
        <div>
          <h1>{t("Order Log")}</h1>
          <div className="po2-desc">{t("Every order written at your show - drill-through target for every dashboard figure")}</div>
        </div>
      </div>
      {shows.length === 0 ? (
        <div className="po2-panel">
          <div className="po2-empty">
            <div className="po2-ic">◇</div>
            <p>{t("No shows are assigned to you as organizer yet.")}</p>
          </div>
        </div>
      ) : (
        <div className="po2-panel">
          <div className="po2-field">
            <label>{t("Show")}</label>
            <Select
              style={{ width: 320 }}
              placeholder={t("Choose a show")}
              onChange={(showId) => navigate("/orderReport", { state: { showId } })}
              options={shows.map((s) => ({ value: s.showId, label: `${s.showName} (${s.city}, ${s.state})` }))}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderLog;
